import React from 'react';
import { createComponent, styled } from '@workday/canvas-kit-react/common';
import { Flex } from '@workday/canvas-kit-react/layout';
import { borderRadius, colors, space } from '@workday/canvas-kit-react/tokens';
const StyledCountContainer = styled(Flex.as('span'))({
    borderTopLeftRadius: borderRadius.zero,
    borderTopRightRadius: borderRadius.m,
    borderBottomLeftRadius: borderRadius.zero,
    borderBottomRightRadius: borderRadius.m,
});
export const PillCount = createComponent('span')({
    displayName: 'Pill.Avatar',
    Component: ({ children, ...elemProps }, ref, Element) => {
        return (React.createElement(StyledCountContainer, Object.assign({ display: "inline-flex", alignItems: "center", justifyContent: "center", as: Element, height: 22, minWidth: 22, padding: `0  ${space.xxxs}`, marginInlineEnd: `-${space.xxs}`, marginInlineStart: `${space.xxxs}`, backgroundColor: colors.soap500, "data-count": "ck-pill-count", ref: ref }, elemProps), children));
    },
});
